function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 22px;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 15px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { PureComponent, Fragment } from "react";
import propTypes from "prop-types";
import { Flipper } from "react-flip-toolkit";
import { requests, utils } from "../../../modules/product";
import { requests as bundleRequests } from "../../../modules/bundles";
import { Grid, Row, SpacedCol, Col } from "../../grid";
import connectRequest from "../../../utils/connect-request";
import Progress from "../../progress";
import Title from "../../title";
import ProductListToolbar from "./toolbar";
import { MutedText, MediumText, EngravedText, CenteredText } from "../../text";
import { context, withContext } from "../../wr-context";
import Product from "./product";
import { CategoriesRow } from "../../categories";
import styled from "styled-components";
import i18n from "../../../utils/i18n";
import { PromiseState } from "react-refetch";
import InputRange from "../../input-range";
import Carousel from "../../carousel";
import { debounce } from "lodash";
import mixpanel from "mixpanel-browser";
import { isAnalyticsEnabled } from "../../../modules/analytics";
var SubTitle = styled.p(_templateObject());
var ProgressContainer = styled.div(_templateObject1());
var RangeWrapper = styled.div(_templateObject2());
var debouncedSearchTracking = debounce(function(searchInput) {
    if (searchInput) mixpanel.track(context.constants.analytics.searchboxUsed, {
        input: searchInput
    });
}, 500);
var ProductList = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ProductList, PureComponent);
    var _super = _createSuper(ProductList);
    function ProductList() {
        _classCallCheck(this, ProductList);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            filter: "",
            listMode: "grid",
            selectedProduct: null
        };
        _this.rangeValuesSet = false;
        _this.handleChangeFilter = function(e) {
            isAnalyticsEnabled() && debouncedSearchTracking(e.target.value);
            return _this.setState({
                filter: e.target.value
            });
        };
        _this.handleChangeListMode = function(listMode) {
            return _this.setState({
                listMode: listMode
            });
        };
        _this.handleSingleSelection = function(id, product, fullProduct) {
            var singleSelection = true;
            var selectedProduct = _this.state.selectedProduct;
            if (selectedProduct === id) {
                id = null;
            }
            _this.setState({
                selectedProduct: id
            }, _this.handleProductSelection(product, {
                singleSelection: singleSelection,
                fullProduct: fullProduct
            }));
        };
        _this.handleProductSelection = function(product, param) {
            var singleSelection = param.singleSelection, removeSelection = param.removeSelection, fullProduct = param.fullProduct;
            var _actions = context.actions, addProductToCart = _actions.addProductToCart, removeProductFromCart = _actions.removeProductFromCart;
            var cart = context.state.cart;
            if (singleSelection) {
                var removeItem = cart.find(function(product) {
                    if (product.mainProduct) return product.id;
                });
                var sameItem = cart.find(function(prod) {
                    if (prod.mainProduct && prod.id === product.id) return prod.id;
                });
                if (!removeItem) {
                    addProductToCart(product, fullProduct);
                } else if (sameItem) {
                    removeProductFromCart(removeItem.id, removeItem);
                } else {
                    removeProductFromCart(removeItem.id, removeItem);
                    addProductToCart(product, fullProduct);
                }
            } else if (removeSelection) {
                var removeItem1 = cart.find(function(prod) {
                    return prod.id === product.id;
                });
                removeItem1 && removeProductFromCart(removeItem1.id, removeItem1);
            } else {
                addProductToCart(product, fullProduct);
            }
        };
        _this.renderProducts = function(products, selectedProduct, singleSelection) {
            var productProps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            var _props = _this.props, noAnimation = _props.noAnimation, useCarousel = _props.useCarousel;
            var ContainerComponent = noAnimation ? "div" : Flipper;
            var containerProps = noAnimation ? {} : {
                spring: context.theme.components.productList.spring,
                flipKey: products.map(function(v) {
                    return v.id;
                }).reduce(function(acc, s) {
                    return acc.concat(s);
                }, "")
            };
            var ListContainerComponent = useCarousel ? Carousel : Fragment;
            return /*#__PURE__*/ React.createElement(ContainerComponent, _extends({}, containerProps), /*#__PURE__*/ React.createElement(Row, _extends({}, context.theme.components.productList.centered), /*#__PURE__*/ React.createElement(ListContainerComponent, _extends({}, useCarousel), products.map(function(product, index) {
                return /*#__PURE__*/ React.createElement(Product, _extends({
                    key: product.id || index,
                    product: product,
                    selected: selectedProduct === product.id,
                    singleSelection: singleSelection,
                    noAnimation: noAnimation
                }, productProps));
            }))));
        };
        _this.getProductsFetch = function() {
            var _props = _this.props, showBundles = _props.showBundles, bundlesFetch = _props.bundlesFetch, _context = _props.context, selectedCatalogId = _context.state.selectedCatalogId, _constants = _context.constants, catalogIds = _constants.client.catalogIds;
            var relevantIds = selectedCatalogId ? [
                selectedCatalogId
            ] : catalogIds;
            var fetches = _toConsumableArray(relevantIds.map(function(id) {
                return _this.props["productsFetch:".concat(id)];
            }));
            if (showBundles) fetches.push(bundlesFetch);
            return PromiseState.all(fetches);
        };
        _this.getProductsAndCategories = function() {
            var _props = _this.props, searchableKeys = _props.searchableKeys, productsToDisplay = _props.productsToDisplay, showPriceFilter = _props.showPriceFilter, filterProducts = _props.filterProducts;
            var productsFetch = _this.getProductsFetch();
            var ref = filterProducts ? filterProducts(productsFetch.value, _this.state.filter, searchableKeys || [], productsToDisplay || [], showPriceFilter) : utils.filterProducts(productsFetch.value, _this.state.filter, searchableKeys || [], productsToDisplay || [], showPriceFilter), _products = ref.products, products = _products === void 0 ? [] : _products, _categories = ref.categories, categories = _categories === void 0 ? [] : _categories;
            return {
                products: products,
                categories: categories
            };
        };
        _this.getRangeValues = function(products) {
            var context = _this.props.context;
            var actions = context.actions;
            if (_this.rangeValuesSet !== context.state.selectedCatalogId) {
                var productsValues = [];
                products.forEach(function(prod) {
                    Object.keys(prod).forEach(function(key) {
                        var ref, ref1;
                        (ref = prod[key]) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(product) {
                            if (product.pricing.value) {
                                productsValues.push(parseInt(product.pricing.value));
                            }
                        });
                    });
                });
                if (productsValues.length) {
                    var _Math, _Math1;
                    actions.updateMaxPriceFilterValue((_Math = Math).max.apply(_Math, _toConsumableArray(productsValues)));
                    actions.updatePriceFilterValues([
                        0,
                        (_Math1 = Math).max.apply(_Math1, _toConsumableArray(productsValues))
                    ]);
                } else {
                    actions.updateMaxPriceFilterValue(0);
                    actions.updatePriceFilterValues([
                        0,
                        0
                    ]);
                }
                _this.rangeValuesSet = context.state.selectedCatalogId;
            }
        };
        return _this;
    }
    var _proto = ProductList.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.resetSelectedCategories) {
            context.actions.resetCategoryFilters();
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var productFetch = this.getProductsFetch();
        if (productFetch.pending || productFetch.rejected) return;
        var ref = this.getProductsAndCategories(), _products = ref.products, products = _products === void 0 ? [] : _products;
        this.getRangeValues(products);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, toolbar = _props.toolbar, toolbarType = _props.toolbarType, hidePriceAndDurationIfZero = _props.hidePriceAndDurationIfZero, displayPriceOnList = _props.displayPriceOnList, showPointsLabel = _props.showPointsLabel, displayDurationOnList = _props.displayDurationOnList, hideButtons = _props.hideButtons, samePageSelection = _props.samePageSelection, singleSelection = _props.singleSelection, showAddedToOrderBadge = _props.showAddedToOrderBadge, showAddedToOrderIcon = _props.showAddedToOrderIcon, showCategories = _props.showCategories, categoriesColSize = _props.categoriesColSize, splitOnCategories = _props.splitOnCategories, showTitle = _props.showTitle, categorySubTitle = _props.categorySubTitle, _toolBarColSize = _props.toolBarColSize, toolBarColSize = _toolBarColSize === void 0 ? {
            xs: 12
        } : _toolBarColSize, showSupplierName = _props.showSupplierName, singleSelectionCategory = _props.singleSelectionCategory, showFilters = _props.showFilters, showSortingButton = _props.showSortingButton, showLayoutButtons = _props.showLayoutButtons, context = _props.context, showPriceFilter = _props.showPriceFilter, showHeaderRows = _props.showHeaderRows, configureButtonLabel = _props.configureButtonLabel, filterByCategoryLabel = _props.filterByCategoryLabel, categoryClassNameMapping = _props.categoryClassNameMapping, headerRowsColors = _props.headerRowsColors, headerRowsPosition = _props.headerRowsPosition, strictFilter = _props.strictFilter, retrieveProducts = _props.retrieveProducts, sortProducts = _props.sortProducts, productTarget = _props.productTarget, renderProductBody = _props.renderProductBody, renderCustomProductHeaderTitle = _props.renderCustomProductHeaderTitle, renderCustomProductFooterButton = _props.renderCustomProductFooterButton, orderCategoriesAZ = _props.orderCategoriesAZ, orderCategoriesZA = _props.orderCategoriesZA, resetSelectedCategories = _props.resetSelectedCategories, toolbarRenderer = _props.toolbarRenderer, ContainerComponent = _props.containerComponent, fromDecisionTree = _props.fromDecisionTree;
        var _state = this.state, listMode = _state.listMode, selectedProduct = _state.selectedProduct;
        var productsFetch = this.getProductsFetch();
        if (productsFetch.pending) {
            return /*#__PURE__*/ React.createElement(ProgressContainer, {
                "data-testid": "list-loading-progress"
            }, /*#__PURE__*/ React.createElement(Progress, null));
        } else if (productsFetch.rejected) {
            return /*#__PURE__*/ React.createElement(ContainerComponent, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, {
                "data-testid": "list-loading-error"
            }, i18n("productList.loadingError"))))));
        }
        var ref = this.getProductsAndCategories(), _products = ref.products, products = _products === void 0 ? [] : _products, _categories = ref.categories, categories = _categories === void 0 ? [] : _categories;
        var productsToShow = !splitOnCategories ? retrieveProducts ? retrieveProducts(products, this.state.filter) : utils.retrieveProducts(products) : null;
        var activeSorting = context.state.activeSorting;
        productsToShow = sortProducts ? sortProducts(productsToShow, activeSorting) : activeSorting ? utils.sortProducts(productsToShow, activeSorting) : productsToShow;
        if (strictFilter) {
            productsToShow = productsToShow.filter(function(p) {
                return context.state.categoryFilters.every(function(v) {
                    return p.categories.map(function(c) {
                        return c.id;
                    }).includes(v);
                });
            });
        }
        var productProps = {
            listMode: listMode,
            samePageSelection: samePageSelection,
            hidePriceAndDurationIfZero: hidePriceAndDurationIfZero,
            displayPriceOnList: displayPriceOnList,
            showPointsLabel: showPointsLabel,
            displayDurationOnList: displayDurationOnList,
            hideButtons: hideButtons,
            showAddedToOrderBadge: showAddedToOrderBadge,
            showAddedToOrderIcon: showAddedToOrderIcon,
            showSupplierName: showSupplierName,
            showHeaderRows: showHeaderRows,
            configureButtonLabel: configureButtonLabel,
            categoryClassNameMapping: categoryClassNameMapping,
            headerRowsColors: headerRowsColors,
            headerRowsPosition: headerRowsPosition,
            productTarget: productTarget,
            renderBody: renderProductBody,
            renderCustomHeaderTitle: renderCustomProductHeaderTitle,
            renderCustomProductFooterButton: renderCustomProductFooterButton,
            handleSingleSelection: this.handleSingleSelection,
            handleProductSelection: this.handleProductSelection,
            fromDecisionTree: fromDecisionTree
        };
        var renderParts = {
            toolbar: toolbar && /*#__PURE__*/ React.createElement(Row, {
                center: "xs"
            }, /*#__PURE__*/ React.createElement(Col, _extends({}, toolBarColSize), /*#__PURE__*/ React.createElement(ProductListToolbar, {
                onChangeFilter: this.handleChangeFilter,
                filter: this.state.filter,
                onChangeListMode: this.handleChangeListMode,
                listMode: this.state.listMode,
                filterByCategoryLabel: filterByCategoryLabel,
                toolbarType: toolbarType,
                showFilters: showFilters,
                showSortingButton: showSortingButton,
                showLayoutButtons: showLayoutButtons,
                orderCategoriesAZ: orderCategoriesAZ,
                orderCategoriesZA: orderCategoriesZA,
                resetSelectedCategories: resetSelectedCategories,
                customRenderer: toolbarRenderer
            }))),
            categories: showCategories && /*#__PURE__*/ React.createElement(CategoriesRow, {
                colSize: categoriesColSize
            }),
            priceFilter: !(context.state.priceFilter.minValue >= context.state.priceFilter.maxValue) && showPriceFilter && /*#__PURE__*/ React.createElement(RangeWrapper, null, /*#__PURE__*/ React.createElement(Row, {
                center: "xs"
            }, /*#__PURE__*/ React.createElement(Col, _extends({}, toolBarColSize), i18n("productList.priceFilterLabel")), /*#__PURE__*/ React.createElement(Col, _extends({}, toolBarColSize), /*#__PURE__*/ React.createElement(Row, {
                center: "xs",
                middle: "xs"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 1
            }, context.state.priceFilter.values[0]), /*#__PURE__*/ React.createElement(Col, {
                xs: 10
            }, /*#__PURE__*/ React.createElement(InputRange, {
                step: 1,
                minValue: context.state.priceFilter.minValue,
                maxValue: context.state.priceFilter.maxValue,
                values: context.state.priceFilter.values,
                onChange: function(values) {
                    return context.actions.updatePriceFilterValues(values);
                }
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 1
            }, context.state.priceFilter.values[1]))))),
            productList: !splitOnCategories ? productsToShow.length > 0 && /*#__PURE__*/ React.createElement("div", {
                className: "products-container"
            }, this.renderProducts(productsToShow, selectedProduct, singleSelection, productProps)) : products.length > 0 && products.map(function(category, index) {
                var _this1 = _this;
                /*#__PURE__*/ return React.createElement("div", {
                    key: index,
                    className: "products-container"
                }, Object.entries(category).length > 0 && Object.keys(category).map(function(key) {
                    var ref;
                    var productsToRender = category[key];
                    var title = (ref = categories.find(function(cat) {
                        return cat.id === key;
                    })) === null || ref === void 0 ? void 0 : ref.name;
                    var isSingleSelection = singleSelection || singleSelectionCategory && singleSelectionCategory === key;
                    if (productsToRender.length === 0) return null;
                    return /*#__PURE__*/ React.createElement("div", {
                        key: key
                    }, showTitle && /*#__PURE__*/ React.createElement(Title, {
                        className: "title"
                    }, title), categorySubTitle && categorySubTitle.id === key && /*#__PURE__*/ React.createElement(Row, {
                        middle: "xs",
                        center: "xs"
                    }, /*#__PURE__*/ React.createElement(Col, {
                        lg: 8,
                        md: 8,
                        sm: 12,
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(SubTitle, null, categorySubTitle.label))), _this1.renderProducts(productsToRender, selectedProduct, Boolean(isSingleSelection), productProps));
                }));
            }),
            noProductsMessage: !products.length && /*#__PURE__*/ React.createElement(Row, {
                center: "xs"
            }, /*#__PURE__*/ React.createElement(SpacedCol, {
                xs: 12
            }, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(MutedText, {
                "data-testid": "list-empty-label"
            }, i18n("productList.noItemsFound")))))))
        };
        var renderOptions = {
            products: products,
            productsToShow: productsToShow
        };
        return /*#__PURE__*/ React.createElement(ContainerComponent, null, this.props.children(renderParts, renderOptions));
    };
    return ProductList;
}(PureComponent);
ProductList.propTypes = {
    toolbar: propTypes.bool,
    hideButtons: propTypes.bool,
    displayPriceOnList: propTypes.oneOfType([
        propTypes.bool,
        propTypes.func
    ]),
    showPointsLabel: propTypes.bool,
    displayDurationOnList: propTypes.bool,
    showAddedToOrderBadge: propTypes.bool,
    showAddedToOrderIcon: propTypes.bool,
    samePageSelection: propTypes.bool,
    singleSelection: propTypes.bool,
    splitOnCategories: propTypes.bool,
    showTitle: propTypes.bool,
    showLayoutButtons: propTypes.bool,
    showFilters: propTypes.bool,
    showSortingButton: propTypes.bool,
    showHeaderRows: propTypes.bool,
    showPriceFilter: propTypes.bool,
    configureButtonLabel: propTypes.string,
    filterByCategoryLabel: propTypes.string,
    categoryClassNameMapping: propTypes.array,
    headerRowsColors: propTypes.array,
    headerRowsPosition: propTypes.string,
    orderCategoriesAZ: propTypes.bool,
    orderCategoriesZA: propTypes.bool,
    resetSelectedCategories: propTypes.bool,
    containerComponent: propTypes.any,
    searchableKeys: propTypes.arrayOf(propTypes.string),
    showSupplierName: propTypes.bool,
    showCategories: propTypes.bool,
    productTarget: propTypes.string,
    filterProducts: propTypes.any,
    retrieveProducts: propTypes.any,
    children: propTypes.any,
    noAnimation: propTypes.bool,
    useCarousel: propTypes.oneOfType([
        propTypes.object,
        propTypes.bool
    ]),
    fromDecisionTree: propTypes.bool,
    strictFilter: propTypes.bool,
    renderCustomProductFooterButton: propTypes.any
};
ProductList.defaultProps = {
    searchableKeys: [
        "name"
    ],
    showAddedToOrderBadge: true,
    showAddedToOrderIcon: false,
    hideButtons: false,
    splitOnCategories: false,
    showTitle: true,
    showSupplierName: false,
    showCategories: false,
    showLayoutButtons: true,
    showFilters: false,
    showSortingButton: false,
    showHeaderRows: false,
    showPriceFilter: false,
    orderCategoriesAZ: false,
    orderCategoriesZA: false,
    resetSelectedCategories: false,
    configureButtonLabel: i18n("productList.configure"),
    filterByCategoryLabel: i18n("toolbar.filterByCategory"),
    categoryClassNameMapping: [],
    headerRowsColors: [],
    headerRowsPosition: "default",
    productTarget: "_self",
    filterProducts: null,
    retrieveProducts: null,
    containerComponent: Grid,
    children: function(renderParts) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, renderParts.toolbar, renderParts.categories, renderParts.priceFilter, renderParts.productList, renderParts.noProductsMessage);
    },
    noAnimation: false,
    useCarousel: false,
    fromDecisionTree: false,
    strictFilter: false
};
var FinalExport = withContext(connectRequest(function(param) {
    var showBundles = param.showBundles, context = param.context;
    var queuedRequests = {};
    var selectedCatalogId = context.state.selectedCatalogId, _constants = context.constants, catalogIds = _constants.client.catalogIds;
    var finalIds = selectedCatalogId ? [
        selectedCatalogId
    ] : catalogIds;
    finalIds.forEach(function(catalogId) {
        queuedRequests["productsFetch:".concat(catalogId)] = requests.fetchProductsByCatalogId(catalogId);
    });
    if (showBundles) {
        queuedRequests.bundlesFetch = bundleRequests.fetchBundles({
            catalogId: selectedCatalogId
        });
    }
    return queuedRequests;
})(ProductList));
export { Product };
export default FinalExport;
